import { render, staticRenderFns } from "./wy-evaluation-new-question.vue?vue&type=template&id=c217dfb4&"
import script from "./wy-evaluation-new-question.vue?vue&type=script&lang=js&"
export * from "./wy-evaluation-new-question.vue?vue&type=script&lang=js&"
import style0 from "./wy-evaluation-new-question.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports